// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Tautz';
    src: url('https://webshopresource-1ccb8.kxcdn.com/assets/fonts/Tautz.ttf') format('truetype');
}

/* width */

::-webkit-scrollbar {
    width: 9px;
}

/* Track */

::-webkit-scrollbar-track {
    background-color: transparent;
}

/* Handle */

::-webkit-scrollbar-thumb {
    background: #101010;
}

/* Handle on hover */

::-webkit-scrollbar-thumb:hover {
    background: #555;
}

html body {
    color: #000;
    font-family: Roboto !important;
}

.navbar-header .navbar-brand i {
    display: none !important;
}

.navbar-header .navbar-brand {
}

#navbarCollapse .nav.navbar-nav:not(.navbar-right) {
    display: flex;
    justify-content: center;
}

#navbarCollapse .nav.navbar-nav:not(.navbar-right) li {
    display: flex;
}

#navbarCollapse .nav.navbar-nav i.fa {
    color: #fff !important;
}

#navbarCollapse .nav.navbar-nav .ui-mnit-root {
    color: #fff !important;
    font-size: 1.2em !important;
    font-family: Roboto;
}

#navbarCollapse .nav.navbar-nav .ui-user-fullname {
    display: none !important;
}

#navbarCollapse .dropdown.open ul.dropdown-menu li,
#navbarCollapse .dropdown.open ul.dropdown-menu li a {
    width: 100%;
    font-family: Roboto;
}

div.modal-header.ng-scope {
    background-color: #c9bfb4;
    color: #2d7194;
}

.table tr:first-child > th {
    background-color: #f9f9f9;
}

.document-fields-group .title {
    background-color: #f9f9f9 !important;
    padding-top: 12px !important;
    color: #2d7194 !important;
    font-family: Tautz !important;
    font-size: 14px !important;
}

.document-fields-group {
    background-color: #f9f9f9;
}

div.input-group-addon {
    color: #2d7194;
}

h1 {
    color: #2d7194;
}

h2 {
    color: #2d7194;
}

h3 {
    color: #2d7194;
    margin-top: 28px;
    margin-bottom: 10px;
    margin-left: 15px;
}

h1, h2, h3, h4,
span.input-group-addon {
    font-family: Tautz;
}

table thead tr th {
    overflow: hidden;
}

.modal-header > strong {
    text-transform: uppercase;
    font-family: Tautz;
}

.control-label {
    font-family: Tautz;
    color: #2d7194;
}

.input-group-addon {
    font-weight: bold;
}

.modal-body .btn-sm {
    font-weight: bold !important;
}

body[ng-app="webshop-admin-app"] ul li label {
    padding-left: 3px;
}

body[ng-app="webshop-admin-app"] .page-heading .input-group-addon label,
body[ng-app="webshop-admin-app"] .page-title .input-group-addon label {
    padding-top: 3px;
    margin-bottom: 1px;
    padding-left: 5px;
    font-weight: normal;
}

body[ng-app="webshop-admin-app"] .row-new {
    display: inline-block;
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./app/assets/css/base-theme.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,6FAA6F;AACjG;;AAEA,UAAU;;AACV;IACI,UAAU;AACd;;AAEA,UAAU;;AACV;IACI,6BAA6B;AACjC;;AAEA,WAAW;;AACX;IACI,mBAAmB;AACvB;;AAEA,oBAAoB;;AACpB;IACI,gBAAgB;AACpB;;AAGA;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;AACA;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,4BAA4B;IAC5B,yBAAyB;IACzB,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf","sourcesContent":["@font-face {\r\n    font-family: 'Tautz';\r\n    src: url('https://webshopresource-1ccb8.kxcdn.com/assets/fonts/Tautz.ttf') format('truetype');\r\n}\r\n\r\n/* width */\r\n::-webkit-scrollbar {\r\n    width: 9px;\r\n}\r\n\r\n/* Track */\r\n::-webkit-scrollbar-track {\r\n    background-color: transparent;\r\n}\r\n\r\n/* Handle */\r\n::-webkit-scrollbar-thumb {\r\n    background: #101010;\r\n}\r\n\r\n/* Handle on hover */\r\n::-webkit-scrollbar-thumb:hover {\r\n    background: #555;\r\n}\r\n\r\n\r\nhtml body {\r\n    color: #000;\r\n    font-family: Roboto !important;\r\n}\r\n\r\n.navbar-header .navbar-brand i {\r\n    display: none !important;\r\n}\r\n\r\n.navbar-header .navbar-brand {\r\n}\r\n\r\n#navbarCollapse .nav.navbar-nav:not(.navbar-right) {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n#navbarCollapse .nav.navbar-nav:not(.navbar-right) li {\r\n    display: flex;\r\n}\r\n\r\n#navbarCollapse .nav.navbar-nav i.fa {\r\n    color: #fff !important;\r\n}\r\n\r\n#navbarCollapse .nav.navbar-nav .ui-mnit-root {\r\n    color: #fff !important;\r\n    font-size: 1.2em !important;\r\n    font-family: Roboto;\r\n}\r\n\r\n#navbarCollapse .nav.navbar-nav .ui-user-fullname {\r\n    display: none !important;\r\n}\r\n\r\n#navbarCollapse .dropdown.open ul.dropdown-menu li,\r\n#navbarCollapse .dropdown.open ul.dropdown-menu li a {\r\n    width: 100%;\r\n    font-family: Roboto;\r\n}\r\n\r\ndiv.modal-header.ng-scope {\r\n    background-color: #c9bfb4;\r\n    color: #2d7194;\r\n}\r\n\r\n.table tr:first-child > th {\r\n    background-color: #f9f9f9;\r\n}\r\n\r\n.document-fields-group .title {\r\n    background-color: #f9f9f9 !important;\r\n    padding-top: 12px !important;\r\n    color: #2d7194 !important;\r\n    font-family: Tautz !important;\r\n    font-size: 14px !important;\r\n}\r\n\r\n.document-fields-group {\r\n    background-color: #f9f9f9;\r\n}\r\n\r\ndiv.input-group-addon {\r\n    color: #2d7194;\r\n}\r\n\r\nh1 {\r\n    color: #2d7194;\r\n}\r\n\r\nh2 {\r\n    color: #2d7194;\r\n}\r\n\r\nh3 {\r\n    color: #2d7194;\r\n    margin-top: 28px;\r\n    margin-bottom: 10px;\r\n    margin-left: 15px;\r\n}\r\n\r\nh1, h2, h3, h4,\r\nspan.input-group-addon {\r\n    font-family: Tautz;\r\n}\r\n\r\ntable thead tr th {\r\n    overflow: hidden;\r\n}\r\n\r\n.modal-header > strong {\r\n    text-transform: uppercase;\r\n    font-family: Tautz;\r\n}\r\n\r\n.control-label {\r\n    font-family: Tautz;\r\n    color: #2d7194;\r\n}\r\n\r\n.input-group-addon {\r\n    font-weight: bold;\r\n}\r\n\r\n.modal-body .btn-sm {\r\n    font-weight: bold !important;\r\n}\r\n\r\nbody[ng-app=\"webshop-admin-app\"] ul li label {\r\n    padding-left: 3px;\r\n}\r\n\r\nbody[ng-app=\"webshop-admin-app\"] .page-heading .input-group-addon label,\r\nbody[ng-app=\"webshop-admin-app\"] .page-title .input-group-addon label {\r\n    padding-top: 3px;\r\n    margin-bottom: 1px;\r\n    padding-left: 5px;\r\n    font-weight: normal;\r\n}\r\n\r\nbody[ng-app=\"webshop-admin-app\"] .row-new {\r\n    display: inline-block;\r\n    width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
